import { NUMERO_WHATSAPP_SUPORTE } from './constants';

export class Utils {
  public static redirectToWhatsApp(): void {
    window.open(`https://wa.me/${NUMERO_WHATSAPP_SUPORTE}`, "_blank");
  }
}